import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 THE ACADEMIC EDGE™',
  ideal: 'Students who want to pass every subject without retaking again',
  was: '$50',
  now: '$25',
  features: ['12 Complete Volumes', 'Memory & Retention Techniques', 'Anti-Block Exam Protocol', 'Full Semester Organization System', '5 Strategic Bonuses FREE', '7-Day Money-Back Guarantee'],
  cta: '🔥 I want The Academic Edge'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Immediate Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-126" data-mp="3c81rxww2x7h7">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" data-id="element-127" data-mp="3vz72a1ghsvrl">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-gold/40 bg-ink-2 px-6 pb-7 pt-10 text-center shadow-[0_20px_60px_-20px_rgba(212,175,55,0.35)]" data-id="element-128" data-mp="4scmexh4pmqg">
          <h3 className="font-display text-lg font-black text-white" data-id="element-129" data-mp="3i93hzg16bc4s">{plan.name}</h3>
          <p className="mt-2 text-sm text-white/60" data-id="element-130" data-mp="3n6vaab5qd09i">
            <span className="font-semibold text-white/80" data-id="element-131" data-mp="3n5ahapz2dpdr">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-132" data-mp="3rzoi57whwopt">
            <span className="text-base font-medium text-white/40 line-through" data-id="element-133" data-mp="2uizf5avt7geu">{plan.was}</span>
            <div className="text-gold-shine font-display text-4xl font-black" data-id="element-134" data-mp="2zh0ylwx5dhqu">{plan.now}</div>
            <p className="mt-1 text-xs font-semibold text-gold" data-id="element-135" data-mp="2rgcvtv8sadv9">Single payment · Lifetime access</p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-136" data-mp="2mijq13be7lvi">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-white/80" data-id="element-137" data-mp="315mp3efd62ky">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={3} data-id="element-138" data-mp="2w7bcwx1ljfzk" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-139" data-mp="28jttboshjo7o">
            <CTAButton size="md" data-id="element-140" data-mp="23k7fbd4u23xt">{plan.cta}</CTAButton>
          </div>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-white/50" data-id="element-141" data-mp="2igpv7bnvpc39">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-142" data-mp="3tvbtm1ra8krb">
                <Icon className="h-4 w-4 text-gold" data-id="element-143" data-mp="3txg1eusay3wv" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-144" data-mp="a42dnwg2onc" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-gold/25 bg-white/[0.04] p-5 text-left" data-id="element-145" data-mp="8srz58huin9">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-gold" data-id="element-146" data-mp="3nfcwsi57kb2o" />
          <p className="text-[15px] leading-relaxed text-silver" data-id="element-147" data-mp="3nh63tyjqgxb7">
            <span className="font-display font-bold text-white" data-id="element-148" data-mp="3rhgcjiywu1tr">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            Open the volumes and if within the first week you feel it wasn't worth what you paid,
            request your refund and we'll return 100% of your money. No forms, no drama, no
            complications whatsoever.
          </p>
        </div>
      </div>
    </section>;
}